export interface QuickActionChip {
  id: string;
  label: string;
}

interface QuickActionChipsRowProps {
  /** Header text. Defaults to "Quick Action". */
  title?: string;
  /** Chip definitions; rendered as a vertical stack. */
  chips: QuickActionChip[];
  /** Invoked when a chip is clicked. Phase 4 fires a toast stub; Phase 5 routes the chip's prompt to the LLM. */
  onChipClick: (chip: QuickActionChip) => void;
}

/**
 * Row of suggestion chips rendered in `BaseChatPanel`'s `belowMessages` slot —
 * appears just above the input. Used by the category-mode Performance chatbot
 * to surface canned analytical questions ("What's driving Women's Pajama Set
 * decline?"). Wired to the LLM Q&A loop in Phase 5.
 */
export function QuickActionChipsRow({
  title = 'Quick Action',
  chips,
  onChipClick,
}: QuickActionChipsRowProps) {
  if (chips.length === 0) return null;
  return (
    <div className="px-4 pb-3">
      <div className="rounded-xl border p-3">
        <h3 className="mb-2 text-xs font-semibold">{title}</h3>
        <div className="space-y-1.5">
          {chips.map((chip) => (
            <button
              key={chip.id}
              type="button"
              className="text-muted-foreground hover:bg-muted w-full cursor-pointer rounded-lg border px-3 py-2 text-left text-xs transition-colors"
              onClick={() => {
                onChipClick(chip);
              }}
            >
              {chip.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
